import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Context as CartContext } from '../context/cart';
import { Context as RestaurantContext } from '../context/restaurant';
import { Context as AlertContext } from '../context/alert';
import MainLayout from '../layouts/mainLayout';
import CartProducts from '../features/cart/components/cartProducts';
import TopBar from '../layouts/place/topBar';
import { restaurantTypes } from '../enums/restaurantTypes';
import { useTableSseConnection } from '../hooks/useTableSseConnection';

const CartPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useTableSseConnection();

  const { state: cartState, removeProductFromCart, applyDiscounts } = useContext(CartContext);
  const { state: restaurantState, getMenu } = useContext(RestaurantContext);
  const { alertController } = useContext(AlertContext);

  const getMenuAsync = async () => {
    const { locked, menu, discountCartService } = await getMenu();

    if (restaurantState.restaurant.type === restaurantTypes.OrderAndPay) {
      applyDiscounts(discountCartService);
    } else if (!locked && !menu) {
      alertController.warning({ text: t('errors.noMenu') });
    }
  };

  useEffect(() => {
    if (restaurantState.menuGot) {
      return;
    }

    getMenuAsync();
  }, []);

  return (
    <MainLayout noFooter>
      <div className="sticky top-0 bg-white z-10">
        <TopBar title={t('header.yourOrder')} onBack={() => navigate('/menu')} />
      </div>
      <CartProducts
        cart={cartState.cart}
        onRemove={(productId, index) => {
          removeProductFromCart(productId, index, restaurantState.discountCartService);
        }}
      />
    </MainLayout>
  );
};

export default CartPage;
